import { css } from '@emotion/react';

import generateEmotionClasses from 'bundles/browse-common/components/Pill/generateEmotionClasses';

export const classes = generateEmotionClasses('PillGroup', ['pillGroup', 'group']);

const getPillGroupCss = css`
  .${classes.pillGroup} {
    min-height: 32px;
    gap: var(--cds-spacing-200) var(--cds-spacing-100);
  }

  .${classes.group} {
    display: flex;
    flex-wrap: wrap;
    gap: var(--cds-spacing-100) var(--cds-spacing-100);
  }
`;

export default getPillGroupCss;
